import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo-footer.png'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-top\"><img src=\"" + _imports_0 + "\" alt=\"\"><div class=\"right-content\"><div class=\"footer-info\"><span>地址:</span><p>广东省深圳市南山区</p><p>前海鸿荣源中心A座8楼803A</p></div><div class=\"footer-info\"><span>邮箱:</span><p class=\"text-p\"><a href=\"mailto:info@heals.asia\">info@heals.asia</a></p></div></div></div><a href=\"https://beian.miit.gov.cn/\" target=\"_blank\" class=\"copy-right\"> 粤ICP备2023051266号 </a>", 2)
const _hoisted_3 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", null, _hoisted_3))
}